/* eslint-disable */
<template>
  <div
    :id="value.id"
    :class="[
      {
        completed: value.completed
      },
      'list-group-item'
    ]"
  >
    <b-row>
      <b-col class="task-center" :md="isTicket ? 5 : 4" style="display:inherit">
        <span v-if="isTicket && value.isLastReplyFromClient" class="red">
          *
        </span>
        <b-col
          :id="`ticket_log_${value.id}`"
          sm="1"
          class="task-number"
          :class="{ 'task-number-grab': !isTicket }"
          >{{ value.number ? value.number : "~" }}</b-col
        >
        <label
          v-if="!isTicket"
          class="checkbox checkbox-primary"
          style="display: inline"
        >
          <input
            v-model="value.completed"
            type="checkbox"
            :value="value.completed"
            @change="closeTask"
          />
          <span class="checkmark"></span>
        </label>
        <!-- <b-badge v-if="isOverdue" pill class="overdue" variant="danger"
          >DUE {{ cappedEndDate | moment("from", "now") }}</b-badge
        > -->

        <a
          v-if="isTicket"
          :id="`description_${value.id}`"
          ref="description"
          style="padding-right: 20px; width: 100%"
          target="_blank"
          :href="`${ncmsTicketUrl}${value.guid}`"
        >
          {{ value.description }}
        </a>
        <input
          v-else
          :id="`description_${value.id}`"
          ref="description"
          v-model="value.description"
          placeholder="..."
          style="padding-right: 20px; width: 100%"
          :class="[{ 'no-point': value.completed }]"
          @input="updateTask"
        />
        <b-popover
          v-if="isTicket"
          :target="`ticket_log_${value.id}`"
          placement="top"
          triggers="hover"
          delay="500"
          :disabled="value.completed"
          custom-class="blue-popover"
        >
          <div class="ticket-log" v-html="value.ticketLog"></div>
        </b-popover>
        <b-popover
          :target="`description_${value.id}`"
          placement="top"
          triggers="hover"
          delay="500"
          :disabled="value.completed"
          custom-class="blue-popover"
        >
          <div class="ticket-log" v-html="threadOrDescription"></div>
        </b-popover>
        <b-badge
          v-show="extrasCount > 0"
          :class="[{ 'no-point': value.completed }, 'extrasCount']"
          pill
          variant="primary"
          >{{ extrasCount }}</b-badge
        >
        <i
          v-b-toggle="`extra_${value.id}`"
          :class="[
            {
              'extras-trigger-active': true,
              'no-point': value.completed
            },
            'nav-icon i-Folder extras-trigger'
          ]"
        />
        <b-icon-clock-history
          class="nav-icon i-Folder timelog-clock cursor-pointer"
          @click="showTimelogModal"
        />
      </b-col>
      <b-col :md="isTicket ? 7 : 8" :class="[{ 'no-point': value.completed }]">
        <b-row class="align-center">
          <b-col :md="isTicket ? 2 : 1" class="hours">
            <input
              v-show="!showDueDates"
              v-model="value.hours"
              placeholder="hours"
              type="number"
              min="0"
              step="0.5"
              @input="updateTask"
            />
          </b-col>
          <b-col :md="isTicket ? 3 : 2" class="datepicker">
            <v-date-picker
              :id="value.id"
              :ref="`${value.id}_datePicker`"
              v-model="dateRange"
              :first-day-of-week="1"
              mode="range"
              :popover="{ placement: 'top', visibility: 'click' }"
              :masks="{ input: 'YYYY/MM/DD' }"
            >
              <div>
                <b-badge
                  v-if="isOverdue"
                  pill
                  class="overdue cursor-pointer"
                  variant="danger"
                  @click="test"
                  >{{ formattedDate }}</b-badge
                >
                <b-badge
                  v-else-if="isDueToday"
                  pill
                  class="overdue cursor-pointer"
                  variant="warning"
                  @click="test"
                  >{{ formattedDate }}</b-badge
                >
                <p v-else class="mb-0 cursor-pointer" @click="test">
                  {{ formattedDate }}
                </p>
              </div>
            </v-date-picker>
          </b-col>
          <b-col :md="isTicket ? 4 : 3" class="difficulty">
            <b-dropdown size="sm" varient="outline" :text="value.status">
              <b-dropdown-item
                v-for="status in statuses"
                :key="status.id"
                @click="changeStatus(status.id)"
                >{{ status.value }}</b-dropdown-item
              >
            </b-dropdown>
          </b-col>
          <b-col v-if="!isTicket" md="2" class="status">
            <b-dropdown
              v-if="!showDueDates"
              :variant="
                value.priority == 'high'
                  ? 'danger'
                  : value.priority == 'medium'
                  ? 'warning'
                  : 'success'
              "
              :text="`${value.priority} priority`"
              size="sm"
            >
              <b-dropdown-item @click="changePriority('low')"
                >Low</b-dropdown-item
              >
              <b-dropdown-item @click="changePriority('medium')"
                >Medium</b-dropdown-item
              >
              <b-dropdown-item @click="changePriority('high')"
                >High</b-dropdown-item
              >
            </b-dropdown>
          </b-col>
          <b-col :md="isTicket ? 1 : 3" class="assignees">
            <VueTagsInput
              v-model="selectedUser"
              :tags="tagUsers"
              :autocomplete-items="items"
              :add-only-from-autocomplete="true"
              class="tags-input list-item-tags-input"
              :placeholder="tagUsers.length ? '' : 'assignee'"
              :max-tags="isTicket ? 1 : 5"
              @tags-changed="newTags => usersChanged(newTags)"
            >
              <div
                slot="autocomplete-item"
                slot-scope="props"
                @click="props.performAdd(props.item)"
              >
                {{ props.item.text }}
              </div>
              <div slot="tag-center" slot-scope="props">
                <ProjectAvatar
                  image-url="@/assets/images/avatars/matthewt.svg"
                  :user="getUserById(props.tag.id)"
                  :hide-nick-name="true"
                  :width="24"
                  :nick-name="props.tag.text"
                  :height="24"
                  :only-initials="true"
                />
              </div>
            </VueTagsInput>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-collapse
      :id="`extra_${value.id}`"
      accordion="tasks"
      class="extras"
      @show="onExtrasToggle"
      @hide="onExtrasToggle"
    >
      <ListItemExtras v-if="extrasExpanded" ref="taskExtras" :task="value" />
    </b-collapse>

    <!--    Time Log Modal-->
    <TimeLogModal
      ref="timeLogModal"
      :quote-id="quoteId"
      :task="value"
      :is-ticket="isTicket"
      :client-id="clientId"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import VueTagsInput from "@johmun/vue-tags-input"
import ProjectAvatar from "@/components/projectAvatar"
import TimeLogModal from "@/components/timeLog/timeLogModal"

export default {
  components: {
    VueTagsInput,
    ProjectAvatar,
    TimeLogModal,
    ListItemExtras: () => import("./listItemExtras")
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    isTicket: {
      type: Boolean,
      default: false
    },
    showDueDates: {
      type: Boolean,
      default: false
    },
    clientId: {
      type: Number,
      required: true
    },
    quoteId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      updateTimer: null,
      selectedUser: "",
      tagUsers: [],
      extrasExpanded: false,
      dateRange: {
        start: new Date(),
        end: new Date()
      },
      awaitingTaskUpdate: false,
      ncmsTicketUrl: process.env.VUE_APP_TICKET_HTTPS
    }
  },

  computed: {
    ...mapState({
      users: state => state.users.all,
      statuses: state => state.statuses.all
    }),

    //Done just for real time updates
    taskUsers() {
      return this.value.users
    },
    startDate() {
      return this.value.start
    },
    endDate() {
      return this.value.end
    },
    ...mapGetters({
      getCurrentUser: "getCurrentUser",
      getUserById: "getUserById",
      getStatusById: "getStatusById",
      getUserByEmail: "getUserByEmail"
    }),
    threadOrDescription() {
      return !this.value.ticketThread || this.value.ticketThread === ""
        ? this.value.description
        : this.value.ticketThread
    },
    // threadOrDescription() {
    //   return !this.value.ticketLog || this.value.ticketLog === ""
    //     ? this.value.description
    //     : this.value.ticketLog
    // },
    formattedDate() {
      let formattedStart = this.$moment(this.dateRange.start).format("DD MMM")
      let formattedEnd = this.$moment(this.dateRange.end).format("DD MMM")
      if (!this.dateRange.start || !this.dateRange.end) return "Due Date"
      return `${formattedStart}${
        formattedStart == formattedEnd ? "" : `-${formattedEnd}`
      }`
    },
    extrasCount() {
      //TODO add files count
      let count = 0
      if (this.value.notes) count += this.value.notes?.length ?? 0
      if (this.value.files) count += this.value.files?.length ?? 0
      return count
    },
    items() {
      return this.users
        ?.filter(i => {
          return (
            !this.tagUsers.map(x => x.id).includes(i.id) &&
            i.firstName?.includesLowerCase(this.selectedUser) &&
            i?.id !== "**Unassigned**"
          )
        })
        .map(x => {
          return {
            id: x.id,
            text: this.getUserName(x)
          }
        })
    },
    isOverdue() {
      var morning = new Date()
      morning.setHours(0)
      morning.setMinutes(0)
      morning.setSeconds(0)
      morning.setMilliseconds(0)
      this.$refs[`${this.value.id}_datePicker`]?.$forceUpdate()
      return !this.value.completed && new Date(this.dateRange.end) < morning
    },
    isDueToday() {
      var morning = new Date()
      morning.setHours(0)
      morning.setMinutes(0)
      morning.setSeconds(0)
      morning.setMilliseconds(0)
      return (
        !this.value.completed &&
        this.$moment(new Date(this.dateRange.end)).diff(morning, "days") == 0
      )
    }
  },
  watch: {
    dateRange() {
      if (!this.loading) {
        this.updateTaskNoDelay()
      }
    },

    taskUsers(val) {
      this.tagUsers =
        val?.map(x => {
          return {
            id: x.id,
            text: x.firstName ?? this.getUserById(x.id).firstName
          }
        }) ?? []
    },
    startDate(val) {
      this.dateRange.start = val
    },
    endDate(val) {
      this.dateRange.end = val
    }
  },
  created() {
    this.tagUsers =
      this.value.users
        ?.filter(x => x)
        .map(x => {
          return {
            id: x.id || this.getUserByEmail(x.email)?.id,
            text: x.firstName ?? this.getUserByEmail(x.email)?.firstName
          }
        }) ?? []
    this.dateRange = {
      start: this.value.start,
      end: this.value.end
    }
    this.$nextTick(() => {
      this.loading = false
    })
  },
  methods: {
    showTimelogModal() {
      this.$refs.timeLogModal.show()
    },
    /**
     *
     * @param user
     * @returns {string}
     */
    getUserName(user) {
      if (!user.firstName) user = this.getUserByEmail(user.id)
      return `${user.firstName} ${user.lastName.substr(0, 1).toUpperCase()}`
    },
    test() {
      // this.$nextTick(() => {
      //   this.$refs[
      //     `${this.value.id}_datePicker`
      //   ].$children[1].$children[0].$refs.pages[0].$refs.days.find(
      //     x => x.day.day == new Date().getDate()
      //   ).$refs.content.style.BackgroundColor = "lightblue"
      // })
    },

    /**
     * Changes priority
     * @param priority
     */
    changePriority(priority) {
      this.value.priority = priority
      this.updateTaskNoDelay()
    },
    /**
     * Changes Status
     * @param statusId
     */
    changeStatus(statusId) {
      this.value.statusId = statusId
      this.value.status = this.getStatusById(statusId).value
      this.updateTaskNoDelay()
    },
    /**
     * Updates tags.
     * Triggers updateTask.
     * @param newTags
     */
    usersChanged(newTags) {
      this.tagUsers = newTags
      this.updateTaskNoDelay()
    },
    /**
     * Updates the Task/Ticket
     */
    updateTask() {
      if (!this.isTicket) {
        if (!this.awaitingTaskUpdate) {
          setTimeout(() => {
            this.$emit("update-task", {
              description: this.value.description,
              completed: this.value.completed,
              hours: this.value.hours,
              statusId: this.value.statusId,
              priority: this.value.priority,
              start: this.$utils.getDate(this.dateRange.start),
              end: this.$utils.getDate(this.dateRange.end),
              id: this.value.id,
              number: this.value.number,
              users: this.tagUsers?.map(x => x.id) ?? [],
              sectionId: this.value.sectionId,
              userId: this.getCurrentUser.id,
              uid: this.$parent.$parent.$parent.$parent.$parent.Uid //For subscription
            })

            this.awaitingTaskUpdate = false
          }, 2100)

          this.awaitingTaskUpdate = true
        }
      } else
        this.$emit("update-ticket", {
          id: this.value.id,
          userId: this.tagUsers?.map(x => x.id)?.find(x => x) ?? "",
          stateId: this.value.statusId,
          start: this.$utils.getDate(this.dateRange.start),
          end: this.$utils.getDate(this.dateRange.end),
          hours: this.value.hours
        })
    },
    /**
     * Updates the Task/Ticket with no delay
     */
    updateTaskNoDelay() {
      if (!this.isTicket) {
        this.$emit("update-task", {
          description: this.value.description,
          completed: this.value.completed,
          hours: this.value.hours,
          statusId: this.value.statusId,
          priority: this.value.priority,
          start: this.$utils.getDate(this.dateRange.start),
          end: this.$utils.getDate(this.dateRange.end),
          id: this.value.id,
          number: this.value.number,
          users: this.tagUsers?.map(x => x.id) ?? [],
          sectionId: this.value.sectionId,
          userId: this.getCurrentUser.id,
          uid: this.$parent.$parent.$parent.$parent.$parent.Uid //For subscription
        })
      } else
        this.$emit("update-ticket", {
          id: this.value.id,
          userId: this.tagUsers?.map(x => x.id)?.find(x => x) ?? "",
          stateId: this.value.statusId,
          start: this.$utils.getDate(this.dateRange.start),
          end: this.$utils.getDate(this.dateRange.end),
          hours: this.value.hours
        })
    },
    closeTask() {
      this.$emit("update-task", {
        description: this.value.description,
        completed: this.value.completed,
        hours: this.value.hours,
        statusId: this.value.statusId,
        priority: this.value.priority,
        start: this.$utils.getDate(this.dateRange.start),
        end: this.$utils.getDate(this.dateRange.end),
        id: this.value.id,
        number: this.value.number,
        users: this.tagUsers?.map(x => x.id) ?? [],
        sectionId: this.value.sectionId,
        userId: this.getCurrentUser.id,
        uid: this.$parent.$parent.$parent.$parent.$parent.Uid //For subscription
      })
    },

    onExtrasToggle() {
      this.extrasExpanded = !this.extrasExpanded
    }
  }
}
</script>

<style scoped>
input {
  border: none;
  background: transparent;
}
input:focus {
  outline: none;
}
.completed {
  background-color: #eaeaea;
  opacity: 0.5;
}
.zap-easy::before {
  content: "\26A1";
}
.zap-medium::before {
  content: "\26A1 \26A1";
}
.zap-difficult::before {
  content: "\26A1 \26A1 \26A1";
}
.extras-trigger {
  cursor: pointer;
  margin-top: 5px;
  opacity: 0;
  transition: 0.3s;
}
.extras-trigger:hover {
  opacity: 1;
}
.extras-trigger-active {
  opacity: 1;
}
.extras {
  margin-top: 10px;
}
.extrasCount {
  padding: 3px;
  height: fit-content;
}
.overdue {
  height: fit-content;
  margin-right: 5px;
  margin-top: 4px;
  text-transform: uppercase;
}
.no-point {
  pointer-events: none;
}

.due-date {
  font-size: 100%;
}

.side-borders {
  border-right: 1px solid #cacaca;
  border-left: 1px solid #cacaca;
}
.task-number {
  white-space: nowrap;
  font-size: 10px;
  margin-top: 2px;
  font-weight: bold;
  padding-left: 0;
}
.task-number:hover {
  cursor: pointer;
}
.task-number-grab:hover {
  cursor: grab !important;
}
.hours {
  border-left: 1px solid #cacaca;
  text-align: right;
}
.hours input {
  text-align: right;
  width: 50px;
}
.difficulty {
  border-left: 1px solid #cacaca;
}
.status {
  border-left: 1px solid #cacaca;
  /* overflow-x: hidden !important; */
}
.assignees {
  border-left: 1px solid #cacaca;
  padding-left: 10px;
}
.datepicker {
  border-left: 1px solid #cacaca;
}
.datepicker p {
  font-size: 12px;
  margin-top: 2px;
  font-weight: bold;
}
.c-red {
  color: red;
}
.cursor-pointer {
  cursor: pointer;
}

@media screen and (max-width: 1400px) {
  .hours input {
    text-align: center;
  }
  /* .datepicker {
    overflow: hidden;
  } */
  .status {
    /* overflow-x: hidden; */
    /* overflow: scroll; */
  }
}

@media screen and (max-width: 850px) {
  .hours input {
    text-align: left;
  }
}

.task-center {
  margin-top: auto;
  margin-bottom: auto;
}

.red {
  color: red !important;
  background: unset !important;
}

.timelog-clock {
  margin-top: 3px;
  margin-left: 13px;
  font-size: 1.1rem;
}
.timeLog-input {
  background: white !important;
  border: solid 0.001px lightgray;
}

textarea {
  background: white;
}
.modal-header-custom {
  font-size: larger;
}
</style>
<style>
input.display-time {
  width: 23rem !important;
  height: 2.2rem !important;
}

.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus {
  background: #3f51b5 !important;
}

/*.hours::-webkit-scrollbar {*/
/*  width: 0.45rem;*/
/*}*/

/*.hours::-webkit-scrollbar-track {*/
/*  background: rgb(41, 41, 41);*/
/*}*/

/*.hours::-webkit-scrollbar-thumb {*/
/*  background: #3f51b5;*/
/*}*/
/*.minutes::-webkit-scrollbar {*/
/*  width: 0.45rem;*/
/*}*/

/*.hours::-webkit-scrollbar-track {*/
/*  background: rgb(41, 41, 41);*/
/*}*/

.minutes {
  height: fit-content !important;
}
</style>
